export default __webpack_public_path__ + "static/media/fauna-2021-ia.7a0f90fe.png";